import React from 'react';
import { Link } from 'react-router-dom';
import { fieldLabels } from '../profileUpdateFields';

// Dismissible banner for profile-update requests a therapist has completed.
// Mirrors NewClientRequestBanner with a green accent. `onDismiss(request)`
// acknowledges one row server-side.
export default function ProfileUpdateCompletedBanner({ requests, onDismiss }) {
  if (!requests || requests.length === 0) return null;

  const fmtWhen = (dt) => {
    if (!dt) return '';
    const d = new Date(dt);
    return isNaN(d) ? '' : d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  };
  const therapistName = (r) =>
    [r.therapist_first_name, r.therapist_last_name].filter(Boolean).join(' ') || 'The therapist';

  return (
    <div style={{ marginBottom: 20 }}>
      {requests.map((r) => (
        <div
          key={r.id}
          style={{
            display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
            background: 'linear-gradient(135deg, #166534 0%, #15803D 100%)',
            color: '#fff', borderRadius: 14, padding: '14px 20px', marginBottom: 10,
            boxShadow: '0 6px 20px rgba(22,101,52,0.22)',
          }}
        >
          <div style={{ flex: 1, minWidth: 220, fontSize: 15, fontWeight: 600 }}>
            ✅ Profile updated: {therapistName(r)} filled in{' '}
            <strong>{fieldLabels(r.requested_fields)}</strong> for <strong>{r.client_name}</strong>
            {fmtWhen(r.completed_at) ? (
              <span style={{ opacity: 0.85, fontWeight: 500 }}> · {fmtWhen(r.completed_at)}</span>
            ) : null}
          </div>
          <Link
            to="/admin/clients"
            style={{
              background: 'rgba(255,255,255,0.16)', color: '#fff', textDecoration: 'none',
              border: '1px solid rgba(255,255,255,0.55)', borderRadius: 8,
              padding: '8px 14px', fontWeight: 600, fontSize: 14, whiteSpace: 'nowrap',
            }}
          >
            View Clients
          </Link>
          <button
            onClick={() => onDismiss(r)}
            style={{
              background: 'transparent', color: 'rgba(255,255,255,0.9)',
              border: '1px solid rgba(255,255,255,0.55)', borderRadius: 8,
              padding: '8px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap',
            }}
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}
